import { render, staticRenderFns } from "./EditChipsInput.vue?vue&type=template&id=595f488c"
import script from "./EditChipsInput.vue?vue&type=script&lang=js"
export * from "./EditChipsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports